import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { AuthActions } from './core/auth/actions/auth.actions';
import { SignUpActionTypes } from './core/auth/actions/auth-sign-up.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public readonly asyncProcessKeys = [
    AuthActions.AuthActionTypes.Login,
    AuthActions.AuthActionTypes.AdminLogin,
    AuthActions.AuthActionTypes.VerifyAdminCode,
    AuthActions.AuthActionTypes.Logout,
    AuthActions.AuthActionTypes.ConfirmTermsOfService,
    AuthActions.AuthActionTypes.RenewCode,
    AuthActions.AuthActionTypes.SessionExpired,
    SignUpActionTypes.SignUp,
    SignUpActionTypes.SignUpConfirmation,
    SignUpActionTypes.SignUpResendConfirmation,
  ];

  constructor(private translate: TranslateService, private store: Store) {}

  ngOnInit(): void {
    this.store.pipe(take(1)).subscribe((loggedIn) => {
      if (!loggedIn) {
        this.setInitialLanguage();
      }
    });
  }

  private setInitialLanguage() {
    const browserLang = navigator.language.split('-')[0];
    const defaultLang = 'en';
    const supportedLangs = this.translate.getLangs();

    const langToUse = supportedLangs.includes(browserLang) ? browserLang : defaultLang;
    this.translate.setDefaultLang(langToUse);
    this.translate.use(langToUse);
  }
}
